<ul class="navbar-nav">
	<li class="nav-item" *ngIf="!loggedIn()">
		<a class="nav-link " [routerLink]="['login']" 
		routerLinkActive="active">
		<i class="fas fa-sign-in-alt"></i> Login</a>
	</li>
	<li class="nav-item" *ngIf="!loggedIn()">
		<a class="nav-link" [routerLink]="['register']" 
		routerLinkActive="active">
		<i class="fas fa-user-plus"></i> Register</a>
	</li>
	<li class="nav-item" *ngIf="loggedIn()">
		<a class="nav-link pointer" (click)="logout()">
			<i class="fas fa-sign-out-alt"></i> Logout</a>
	</li>
	<li class="nav-item" *ngIf="loggedIn()">
		<a class="nav-link" [routerLink]="['account/profile']"
		 routerLinkActive="active">
		 <i class="fas fa-user"></i> Profile</a>
	</li>
</ul>